import React from 'react';
import './App.css';
import HomePage from './HomePage.jsx';

function App() {
  
  return (
    <div className="App">
      <HomePage></HomePage>
    </div>
  );
}

export default App;
